import React from 'react';

const SixCard = () => {
    return (
      <div className="mt-6">
        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6  py-6 justify-center items-center">
          <div className="flex bg-base-100 rounded-lg p-6">
            <div className="p-4">
              <img
                src="	https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/icon-book.png"
                alt=""
              />
            </div>
            <div className="p-2">
              <h1 className="font-bold">24 Hours Library</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
                tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
              </p>
            </div>
          </div>
          <div className="flex bg-base-100 rounded-lg p-6">
            <div className="p-4">
              <img
                src="	https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/icon-ball.png"
                alt=""
              />
            </div>
            <div className="p-2">
              <h1 className="font-bold">24 Hours Library</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
                tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
              </p>
            </div>
          </div>
          <div className="flex bg-base-100 rounded-lg p-6">
            <div className="p-4">
              <img
                src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/icon-higine.png"
                alt=""
              />
            </div>
            <div className="p-2">
              <h1 className="font-bold">24 Hours Library</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
                tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
              </p>
            </div>
          </div>
          <div className="flex bg-base-100 rounded-lg p-6">
            <div className="p-4">
              <img
                src="	https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/icon-social.png"
                alt=""
              />
            </div>
            <div className="p-2">
              <h1 className="font-bold">24 Hours Library</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
                tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
              </p>
            </div>
          </div>
          <div className="flex bg-base-100 rounded-lg p-6">
            <div className="p-4">
              <img
                src="		https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/icon-staff.png"
                alt=""
              />
            </div>
            <div className="p-2">
              <h1 className="font-bold">24 Hours Library</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
                tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
              </p>
            </div>
          </div>
          <div className="flex bg-base-100 rounded-lg p-6">
            <div className="p-4">
              <img
                src="		https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/icon-teachers.png"
                alt=""
              />
            </div>
            <div className="p-2">
              <h1 className="font-bold">24 Hours Library</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
                tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
};

export default SixCard;